var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-block w-100 position-relative"},[_c('fusioncharts',{attrs:{"type":"scrollcombidy2d","width":"100%","height":"400","dataFormat":"json","dataSource":_vm.dataSource}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }